// Data Models for ADDAPT Landing Page

export interface Profile {
  id: string;
  name: string;
  description: string;
  lastUpdated: string; // ISO date string
  createdBy: string;
  ldapGroup?: string;  // Optional - may not always be present
  status: 'active' | 'inactive' | 'processing';
}

export interface UserInfo {
  username: string;
  displayName: string;
  avatar?: string;
  preferences: {
    theme: 'light' | 'dark';
    locale: string;
  };
}

// Authentication Types

export interface CognitoConfig {
  region: string;
  userPoolId: string;
  userPoolWebClientId: string;
  domain: string;
  redirectSignIn: string;
  redirectSignOut: string;
  responseType?: string;
}

// API Gateway configuration
export interface APIGatewayConfig {
  endpoints: Array<{
    name: string;
    endpoint: string;
  }>;
}

// WebSocket configuration  
export interface WebSocketConfig {
  default: string;
  docAgent: string;
}

export interface AuthUser {
  username: string;
  attributes?: {
    email?: string;
    name?: string;
    sub?: string;
    email_verified?: boolean;
    [key: string]: any;
  };
  signInUserSession?: {
    idToken: {
      jwtToken: string;
      payload: any;
    };
    accessToken: {
      jwtToken: string;
      payload: any;
    };
    refreshToken?: {
      token: string;
    };
  };
  // Formatted attributes (added after authentication)
  formattedAttributes?: {
    username: string;      // Formatted username without prefix
    givenName?: string;    // User's given name
    email?: string;        // User's email
    avatarUrl?: string;    // PhoneTool avatar URL
  };
}

export interface AppSettings {
  stage: 'local' | 'beta' | 'gamma' | 'production';
  cognitoConfig: CognitoConfig;
  apiConfig?: {
    endpoints: Array<{
      name: string;
      endpoint: string;
    }>;
  };
  features?: {
    enableAuthentication?: boolean;
    enableMockData?: boolean;
    enableDebugMode?: boolean;
    enableAnalytics?: boolean;
    enableWebSocket?: boolean;
  };
  mockUser?: {
    username: string;
    attributes: {
      email: string;
      name: string;
    };
    formattedAttributes: {
      username: string;
      givenName: string;
      email: string;
      avatarUrl: string;
    };
  };
}

export enum AUTH_STATES {
  SIGNING_IN = 'SIGNING_IN',
  SIGNED_IN = 'SIGNED_IN',
  SIGNED_OUT = 'SIGNED_OUT'
}

export enum USER_TYPE {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL'
}

export interface TableSortingState {
  sortingColumn: {
    sortingField: string;
    sortingDescending: boolean;
  };
}

// Component Props Interfaces

export interface AppState {
  profiles: Profile[];
  loading: boolean;
  user: UserInfo;
}

export interface NavigationProps {
  user: UserInfo;
  onUserMenuClick: (event: any) => void;
}

export interface ProfilesSectionProps {
  profiles: Profile[];
  loading: boolean;
  onCreateProfile: () => void;
  onProfileSelect: (profileId: string) => void;
}

export interface ProfilesTableProps {
  profiles: Profile[];
  loading: boolean;
  onSelectionChange: (selectedItems: Profile[]) => void;
  onSortingChange: (sortingState: TableSortingState) => void;
  onProfileSelect?: (profileId: string) => void;
}
